import ParentClass from './Parent.js';

class Home extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.content-home';
    if(!super.runThisModule(moduleClass)) return;
  }
}

jQuery(document).ready(function() {
	new Home();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/Home.js